import BaseApi from "@api/base.api";
import Http from "@services/http"

export default class AIIntegrationApi extends BaseApi {
    static get entity() {
        return "ai-integration";
    }

    static async getCurrentSearchSummary(data) {
        return await Http.post(`${this.entity}/current-search-summary`, data);
    }

    static async searchKeywords(data) {
        return await Http.post(`${this.entity}/search-keywords`, data);
    }

    static async initDocumentsData(data) {
        return await Http.post(`${this.entity}/init-documents-data`, data);
    }

    static async initClientData(data) {
        return await Http.post(`${this.entity}/init-client-data`, data);
    }
}
